import {Component} from "@angular/core";

@Component({
  selector: 'app-detail-table',
  templateUrl: './creditor-listings.component.html',
  styleUrls: ['../../../detail-screen/detail-screen.component.css'],
})

export class CreditorListingsComponent {
  tableColumns: string[];
  tableData: any[];
  emptyValuePlaceholder = '-';
  showTable: boolean;

  constructor() {
    this.tableColumns = [];
    this.tableData = [];
    this.showTable = true;
  }

}
